export default "__VITE_ASSET__sRr2oeNn__"